// Per-regulator material icon, keyed by slug. Presentation only — the regulator
// list and names come from the backend (GET /regulators); the acronym is the slug
// uppercased. Add an entry here when a new regulator should show a specific icon.
export const REGULATOR_ICONS: Record<string, string> = {
  bcb: 'account_balance',
  cvm: 'trending_up',
  susep: 'health_and_safety',
  spa: 'casino',
};

export const DEFAULT_REGULATOR_ICON = 'gavel';

export const regulatorIcon = (slug: string): string =>
  REGULATOR_ICONS[slug] ?? DEFAULT_REGULATOR_ICON;
